import { cn } from '@/ui/design-system/utils/cn';

/**
 * The grey summary band under a drawer's header: metrics, chart and description.
 * It exists so the sections below it read as separate rather than as more of the
 * same list.
 */
function DrawerBand({ className, children }) {
    return (
        <div
            className={cn('bg-muted px-4 py-4 flex flex-col gap-3', className)}
        >
            {children}
        </div>
    );
}

export default DrawerBand;
